import * as z from "zod";

/**
 * Step 3 of the intent rescue wizard: write the predictive-conversion intent
 * flags + chop subscription billing record onto the team doc and activate
 * the Conversion web pixel. Called from the wizard's final "Set rescue
 * pop-up live" completion, alongside discount + spotlight creation.
 *
 * All team-doc mutations are deferred to this step on purpose: step 2 only
 * mints the Shopify subscription, so a merchant who bails before finishing
 * the wizard never gets predictive conversion flipped on or a chop billing
 * record written. After this runs the team is indistinguishable from a
 * sales-onboarded chop subscription customer — same billing engine, same
 * predictive-conversion lifecycle (intentActivatedAt drives the model build
 * pipeline; the Conversion web pixel drives storefront data collection).
 */
export const activateIntentRescue = {
  name: "activateIntentRescue" as const,
  input: z.object({}),
  output: z.object({}),
};
